import RegItemForm from './reg-item-form'

export default RegItemForm
